import * as Highcharts from "highcharts";

export const chartData = {
  credits: { enabled: false },
  legend: {
    itemMarginTop: 25,
    padding: -10,
    itemStyle: { color: "#6b778c", "font-weight": "normal"
    }
  },
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: "pie"
  },
  title: {
    useHTML: true,
    text: "<strong></strong><br/>Failed SLA Quantity",
    align: "center",
    verticalAlign: "middle",
    y: -10
  },
  tooltip: {
    useHTML: true,
    style: {
      padding: "0px"
    },
    headerFormat: '<table style="min-width:80px;">',
    pointFormat:
      "" +
      '<tr><td style="text-transform: capitalize; color: #ffffff; padding: 0px;">{point.name} </td>' +
      '<td style="text-align: right; color: #ffffff;  padding: 0px;"><b>{point.percentage:.1f}%</b>' +
      "</td></tr>" +
      "<tr><td style='text-transform: capitalize; color: #ffffff; padding: 0px;'>Quantity</td>" +
      '<td style="text-align: right; colzzzor: #ffffff; padding: 0px;"><b>{point.y}</b>' +
      "</td></tr>",
    footerFormat: "</table>"
  },
  plotOptions: {
    pie: {
      colors: ["#EBC844", "#73C8B1", "#F4902D"],
      dataLabels: { enabled: false },
      showInLegend: true
    }
  },
  series: [
    {
      type: "pie",
      name: "Failed",
      innerSize: "70%",
      data: [["Planning", 300], ["Warehouse", 30], ["Transportation", 30]]
    }
  ]
};

